function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Vue from 'vue';
import Router from 'vue-router';
import { roterPre } from '@/settings';
Vue.use(Router);
/* Layout */
import Layout from '@/layout';
import { generateUniqueString } from '@/libs/helper';

// 获取views中以.vue结尾的文件
var contextInfo = require.context('../views', true, /.vue$/);

/**
 * 过滤/components中的vue文件
 * @returns {{}}
 */
var filteredFileNames = function filteredFileNames() {
  var files = {};
  contextInfo.keys().forEach(function (fileName) {
    if (!fileName.includes('/components')) {
      var pathConfig = contextInfo(fileName);
      var path = '/' + fileName.substring(2, fileName.length - 4);
      files[path] = pathConfig.default;
    }
  });
  return files;
};
var files = filteredFileNames();

/**
 * 删除不需要配置路由
 * @param items
 * @param paths
 */
var _removeItems = function removeItems(items, paths) {
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    for (var j = 0; j < paths.length; j++) {
      var path = paths[j];
      if (item.menu_path === path) {
        items.splice(i, 1);
        i--;
        break;
      } else if (item.children) {
        _removeItems(item.children, paths);
        if (item.children.length === 0) {
          delete item.children;
        }
      }
    }
  }
};

/**
 * 处理平台菜单
 * @param menus
 * @param parentPath
 */
var _replaceMenuPath = function replaceMenuPath(menus, parentPath) {
  menus.forEach(function (menu, index) {
    if (menu.children) {
      _replaceMenuPath(menu.children, menu.menu_path);
    }
    if (parentPath !== '/' && menu.menu_path && menu.menu_path.indexOf(parentPath) > -1) {
      menu.new_path = menu.menu_path.replace(parentPath + '/', '');
    }
    // menu.new_path = '/' + menu.component
    menu.component = '/' + menu.component;
  });
};

/**
 * 过滤路由所需要的数据
 * @param routes
 * @param firstRoute
 * @returns {*}
 */
var _filterAsyncRoutes = function filterAsyncRoutes(routes, firstRoute) {
  return routes.map(function (route) {
    var routeRecord = createRouteRecord(route, firstRoute);
    if (route.children != null && route.children && route.children.length) {
      routeRecord.children = _filterAsyncRoutes(route.children, false);
    }
    return routeRecord;
  });
};

/**
 * 创建一条路由记录
 * @param route
 * @param firstRoute
 * @returns {{path: (*|string), meta: {noCache: boolean, icon, title: *}, name: *}}
 */
var createRouteRecord = function createRouteRecord(route, firstRoute) {
  var routeRecord = {
    // path: route.pid === 0 ? route.menu_path : route.new_path ? route.new_path : '/',
    path: firstRoute ? "/".concat(route.menu_path) : route.menu_path,
    name: route.unique_auth + '_' + generateUniqueString(),
    meta: {
      title: route.menu_name,
      icon: route.icon,
      noCache: true
    }
  };
  if (route.pid === 0) {
    routeRecord.component = Layout;
    // 解决父级路由不能定义name属性
    delete routeRecord.name;
  } else if (route.pid > 0 && route.children && route.children.length > 0) {
    // 解决父级不写component 属性,子集的component也不会显示问题
    routeRecord.component = {
      render: function render(e) {
        return e('router-view');
      }
    };
  } else {
    routeRecord.component = files[route.component];
  }
  return routeRecord;
};
import defaultRoutes from '@/router/routes';
import companyRouter from '@/router/company';
export var constantRoutes = [].concat(_toConsumableArray(defaultRoutes), [companyRouter]);

// 解决强制刷新后404找不到页面逻辑
var route404 = {
  path: '*',
  redirect: roterPre + '/404',
  hidden: true
};
/**
 * 根据后台菜单动态生成路由
 */
export var getRouterMenus = function getRouterMenus(entMenuList) {
  var entRouter = [];
  if (entMenuList && entMenuList.length > 0) {
    // 移除不需要处理路由
    _removeItems(entMenuList, ['/admin/user/work']);
    // 处理后台返回的路由结构
    _replaceMenuPath(entMenuList, '/');
    entRouter = _filterAsyncRoutes(entMenuList);
    constantRoutes.push.apply(constantRoutes, _toConsumableArray(entRouter).concat([route404]));

    // 路由重置加载
    resetRouter();
  }
};
var createRouter = function createRouter() {
  return new Router({
    mode: 'history',
    // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;